import * as THREE from "three";
import { UI_LAYER } from "../../layerConstants";

export class TransmissionVisualization {
  private material: THREE.MeshPhysicalMaterial;
  private geometry: THREE.PlaneGeometry;
  private mesh: THREE.Mesh;

  constructor() {
    // These material parameters have been picked so that they essentially just pass through the opaque buffer used for transmissive materials.
    this.material = new THREE.MeshPhysicalMaterial({
      transparent: true,
      transmission: 1.0,
      color: 0xffffff,
      roughness: 0,
      reflectivity: 0,
      metalness: 0,
      specularIntensity: 0,
    });
    this.geometry = new THREE.PlaneGeometry(2, 2);
    this.geometry.userData.isCached = true; // Prevent disposing the geometry when the scene is disposed.
    this.mesh = new THREE.Mesh(this.geometry, this.material);
    this.mesh.matrixAutoUpdate = false;
    this.mesh.matrixWorldAutoUpdate = false;
    this.mesh.layers.set(UI_LAYER); // We don't want the mesh to affect the depth/normal pass
  }

  update(enableVisualization: boolean, scene: THREE.Scene, camera: THREE.Camera): void {
    if (!enableVisualization) {
      if (this.mesh.parent) {
        this.mesh.removeFromParent();
      }
      return;
    }

    camera.add(this.mesh);
    if ((camera as THREE.PerspectiveCamera).isPerspectiveCamera) {
      const perspectiveCamera = camera as THREE.PerspectiveCamera;
      this.mesh.position.z = -(perspectiveCamera.near + 1.0);
      const scale = 1.01 * -this.mesh.position.z * Math.tan(THREE.MathUtils.DEG2RAD * perspectiveCamera.fov * 0.5);
      this.mesh.scale.set(scale * perspectiveCamera.aspect, scale, scale);
    } else {
      const orthoCamera = camera as THREE.OrthographicCamera;
      this.mesh.position.z = -(orthoCamera.near + 1.0);
      this.mesh.scale.set(
        Math.max(orthoCamera.right, Math.abs(orthoCamera.left)),
        Math.max(orthoCamera.top, Math.abs(orthoCamera.bottom)),
        1.0,
      );
    }
    this.mesh.updateMatrix();
    this.mesh.updateMatrixWorld();

    scene.add(this.mesh);
  }
}
